import {
    GET_REQUISITION_DROP_DOWN,
    SET_REQUISITION_DROP_DOWN
} from "./RequisitionDropDownType"

const getRequistionDropDown = (payload : any) => ({
    type: GET_REQUISITION_DROP_DOWN,
    payload
});

const setRequistionDropDown = (requisitionDropDown: any) => ({
    type: SET_REQUISITION_DROP_DOWN,
    requisitionDropDown: requisitionDropDown
});

export {
    getRequistionDropDown,
    setRequistionDropDown
}
